import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export function SetPasswordPage() {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (password.length < 8) {
      setError('Password must be at least 8 characters')
      return
    }
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.updateUser({ password })
    if (error) {
      setError(error.message)
      setLoading(false)
    } else {
      navigate('/dashboard', { replace: true })
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-parchment">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8 border border-parchment-dark">
        <h1 className="text-3xl font-bold text-accent mb-2">Set Password</h1>
        <p className="text-ink-light mb-6">Choose a password for future sign-ins.</p>
        <form onSubmit={handleSubmit}>
          <label htmlFor="password" className="block text-sm font-medium text-ink mb-1">
            New password
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Min. 8 characters"
            required
            minLength={8}
            className="w-full px-3 py-2 border border-parchment-dark rounded-md focus:outline-none focus:ring-2 focus:ring-accent mb-4"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 px-4 bg-accent text-white rounded-md hover:bg-accent-light disabled:opacity-50 font-medium"
          >
            {loading ? 'Saving...' : 'Set password & continue'}
          </button>
        </form>
        {error && <p className="mt-4 text-sm text-danger">{error}</p>}
        <button
          onClick={() => navigate('/dashboard', { replace: true })}
          className="mt-4 text-sm text-ink-light hover:text-ink underline block"
        >
          Skip for now
        </button>
      </div>
    </div>
  )
}
